import { usePackageConfiguration } from '../../contexts';
import { PackageType } from '../../types/PackageType';
import { MultiDayTablesStep } from './MultiDayTablesStep/MultiDayTablesStep';
import { RepeatingTablesStep } from './RepeatingTablesStep/RepeatingTablesStep';

/**
 * TablesStep Router
 *
 * Determines which tables flow to render based on package type:
 * - Multi-day packages (numberOfNights > 1): Fixed day dining options
 * - Repeating packages (numberOfNights === 1): Day 0/1 distribution
 */
export const TablesStep = () => {
  const { packageType } = usePackageConfiguration();

  return packageType === PackageType.REPEATING ? <RepeatingTablesStep /> : <MultiDayTablesStep />;
};
